var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"click":_vm.closeDropdown}},[(_vm.loading)?_c('loader'):_c('div',[_c('n-nav'),_c('router-view',{staticStyle:{"min-height":"70vh"}}),_c('f-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }